module.exports = __webpack_public_path__ + "img/uniritter-branco.148d6c12.svg";